export default __webpack_public_path__ + "static/media/home.8c8b573f.svg";